import { QuoteFillField } from '@pelicargo/types';
import { prettyCount } from '@pelicargo/utils';

/** The quote columns an apply may fill, as the reviewer reads them. */
const QUOTE_FIELD_LABELS: Record<QuoteFillField, string> = {
  awb_number: 'AWB',
  cutoff_at: 'cut-off',
  delivery_address: 'delivery address',
};

/** "2 flights", "AWB and cut-off", "1 flight, AWB and cut-off": everything an apply wrote, in one phrase. */
export const fillsPhrase = (flightCount: number, quoteFields: ReadonlySet<QuoteFillField>): string => {
  const parts = Array.from(quoteFields, (field) => QUOTE_FIELD_LABELS[field]);
  if (flightCount) parts.unshift(prettyCount(flightCount, 'flight'));
  if (!parts.length) return 'nothing';
  if (parts.length === 1) return parts[0];
  return `${parts.slice(0, -1).join(', ')} and ${parts.at(-1)}`;
};
